

import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function LoadingState() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Your Referral Tools</CardTitle>
        <CardDescription>Loading your personalized sharing tools...</CardDescription>
      </CardHeader>
      <CardContent className="flex justify-center py-10">
        <div className="flex flex-col items-center space-y-4 w-full">
          <Skeleton className="h-6 w-48" />
          <Skeleton className="h-10 w-full max-w-md" />
          <Skeleton className="h-32 w-32" />
        </div>
      </CardContent>
    </Card>
  );
}
